export default __webpack_public_path__ + "static/media/Mastr--Sun-Capital.faf76945.jpg";